import r from "dayjs";
import v from "dayjs/plugin/utc";
import T from "query-string";
const f = {
  dateTimeLocal: "YYYY-MM-DD[T]HH:mm:ss",
  dateTimeUTC: "YYYYMMDD[T]HHmmss[Z]",
  allDay: "YYYYMMDD"
};
function i({ startTime: o, endTime: e }, n) {
  const t = f[n];
  return { start: o.format(t), end: e.format(t) };
}
r.extend(v);
const u = T.stringify;
function d(o, e = !0) {
  const { start: n, end: t, duration: a, ...m } = o, c = e ? r(n).utc() : r(n), y = t ? e ? r(t).utc() : r(t) : (() => {
    if (o.allDay)
      return c.add(1, "day");
    if (a && a.length == 2) {
      const s = Number(a[0]), l = a[1];
      return c.add(s, l);
    }
    return e ? r().utc() : r();
  })();
  return {
    ...m,
    startTime: c,
    endTime: y
  };
}
function k(o) {
  const e = d(o), { start: n, end: t } = i(
    e,
    e.allDay ? "allDay" : "dateTimeUTC"
  ), a = {
    action: "TEMPLATE",
    text: e.title,
    details: e.description,
    location: e.location,
    trp: e.busy,
    dates: n + "/" + t,
    recur: e.rRule ? "RRULE:" + e.rRule : void 0
  };
  return e.guests && e.guests.length && (a.add = e.guests.join()), `https://calendar.google.com/calendar/render?${u(a)}`;
}
function E(o) {
  const e = d(o, !1), { start: n, end: t } = i(e, "dateTimeLocal"), a = {
    path: "/calendar/action/compose",
    rru: "addevent",
    startdt: n,
    enddt: t,
    subject: e.title,
    body: e.description,
    location: e.location,
    allday: e.allDay || !1
  };
  return `https://outlook.live.com/calendar/0/action/compose?${u(a)}`;
}
function N(o) {
  const e = d(o, !1), { start: n, end: t } = i(e, "dateTimeLocal"), a = {
    path: "/calendar/action/compose",
    rru: "addevent",
    startdt: n,
    enddt: t,
    subject: e.title,
    body: e.description,
    location: e.location,
    allday: e.allDay || !1
  };
  return `https://outlook.live.com/calendar/0/deeplink/compose?${u(a)}`;
}
function M(o) {
  const e = d(o), { start: n, end: t } = i(
    e,
    e.allDay ? "allDay" : "dateTimeUTC"
  ), a = {
    v: 60,
    title: e.title,
    st: n,
    et: t,
    desc: e.description,
    in_loc: e.location,
    dur: e.allDay ? "allday" : !1
  };
  return `https://calendar.yahoo.com/?${u(a)}`;
}
function C(o) {
  const e = d(o), n = (e.description || "").replace(/,/gm, ",").replace(/;/gm, ";").replace(/\r\n/gm, `
`).replace(/\n/gm, "\\n").replace(/(\\n)[\s\t]+/gm, "\\n"), t = (e.location || "").replace(/,/gm, ",").replace(/;/gm, ";").replace(/\r\n/gm, `
`).replace(/\n/gm, "\\n").replace(/(\\n)[\s\t]+/gm, "\\n"), { start: a, end: m } = i(
    e,
    e.allDay ? "allDay" : "dateTimeUTC"
  ), c = r(/* @__PURE__ */ new Date()).utc().format(f.dateTimeUTC), y = [
    {
      key: "BEGIN",
      value: "VCALENDAR"
    },
    {
      key: "VERSION",
      value: "2.0"
    },
    {
      key: "PRODID",
      value: e.title
    },
    {
      key: "BEGIN",
      value: "VEVENT"
    },
    {
      key: "URL",
      value: e.url
    },
    {
      key: "DTSTART",
      value: a
    },
    {
      key: "DTEND",
      value: m
    },
    {
      key: "DTSTAMP",
      value: c
    },
    {
      key: "RRULE",
      value: e.rRule
    },
    {
      key: "SUMMARY",
      value: e.title
    },
    {
      key: "DESCRIPTION",
      value: n
    },
    {
      key: "LOCATION",
      value: t
    },
    {
      key: "ORGANIZER",
      value: e.organizer
    },
    {
      key: "UID",
      value: Math.floor(Math.random() * 1e5).toString().replace(".", "")
    },
    {
      key: "END",
      value: "VEVENT"
    },
    {
      key: "END",
      value: "VCALENDAR"
    }
  ];
  let s = "";
  return y.forEach((l) => {
    if (l.value)
      if (l.key == "ORGANIZER") {
        const p = l.value;
        s += `${l.key};${encodeURIComponent(
          `CN=${p.name}:MAILTO:${p.email}\r
`
        )}`;
      } else
        s += `${l.key}:${encodeURIComponent(`${l.value}\r
`)}`;
  }), `data:text/calendar;charset=utf8,${s}`;
}
export {
  C as apple,
  d as eventify,
  k as google,
  E as outlook,
  N as outlookMobile,
  M as yahoo
};
//# sourceMappingURL=index.js.map
